import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { provideHighcharts } from 'highcharts-angular';
import Highmaps from 'highcharts/esm/highmaps';
import { CustomElementDefinitions, WebComponentBootstrapModule } from 'src/boilerplate';
import { WebComponents } from 'src/boilerplate/WebComponentDecorator';
import { AuthInterceptorProvider } from './app/common/interceptors/auth.interceptor';
import { XsrfInterceptorProvider } from './app/common/interceptors/xsrf.interceptor';
import { OpenApiPathProvider, apiConfigFactory } from './app/common/util/open-api-provider';
import { ApiModule } from './openapi-client';
import { DashboardComponent } from '@components/dashboard/dashboard.component';
import { HomeComponent } from '@components/home/home.component';
import { TranslocoRootModule } from './transloco-root.module';

/**
 * THIS FILE IS ONLY FOR WEB COMPONENTS THAT SHOULD BE EXPORTED AS A LIBRARY!
 * NO DEMO COMPONENTS MUST BE INCLUDED!
 */

// As WebComponent exposed Angular components
export const exportedComponents: CustomElementDefinitions = [

];

@WebComponents([
  DashboardComponent, HomeComponent
])
@NgModule({
   imports: [
    BrowserModule,
    HttpClientModule,
    RouterModule.forRoot([]),

    DashboardComponent,
    HomeComponent,
    ApiModule.forRoot(apiConfigFactory),
    TranslocoRootModule,
   ],
  providers: [
    AuthInterceptorProvider,
    XsrfInterceptorProvider,
    // highcharts-angular v5 resolves the Highcharts instance via DI. Without this
    // provider <highcharts-chart> throws NG0201. The Highmaps entry point is used
    // so `constructorType: 'mapChart'` (country chart) works too.
    // In v5 the global options (previously set via Highcharts.setOptions in the
    // Widgetservice's init-highcharts.ts) belong in the `options` property here.
    // Highmaps is imported STATICALLY (not via dynamic import()) so it is bundled
    // into the single web-components.js. A dynamic import would emit a lazy chunk
    // that the host portal tries to fetch from its own origin → 404/HTML → MIME
    // "text/html" error. `instance` only needs a Promise, so we wrap the static
    // import in Promise.resolve.
    provideHighcharts({
      instance: () => Promise.resolve(Highmaps),
      options: {
        chart: {
          styledMode: true,
          style: {
            fontFamily: 'Frutiger, Arial, sans-serif;',
            fontSize: '20px',
          },
        },
        lang: {
          decimalPoint: ',',
          thousandsSep: '.',
          loading: 'Daten werden geladen...',
          months: [
            'Januar',
            'Februar',
            'März',
            'April',
            'Mai',
            'Juni',
            'Juli',
            'August',
            'September',
            'Oktober',
            'November',
            'Dezember',
          ],
          weekdays: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
          shortMonths: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
        },
      },
    }),
    OpenApiPathProvider,
  ],
})
export class ExportModule extends WebComponentBootstrapModule {
  constructor() {
    super(exportedComponents);
  }
}
